module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-search",
    class: {
      focused: _vm.focused
    }
  }, [_c('div', {
    staticClass: "ms-box",
    on: {
      "click": _vm.focusInput
    }
  }, [_c('Icon', {
    staticClass: "ms-icon",
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    ref: "input",
    staticClass: "ms-input",
    attrs: {
      "placeholder": _vm.focused ? '搜索菜单名称或分组' : '搜索菜单'
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.move(1)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.move(-1)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.openActive.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        return _vm.close.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.focused && _vm.keyword) ? _c('Icon', {
    staticClass: "ms-clear",
    attrs: {
      "type": "close-circled"
    },
    nativeOn: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.clearKeyword.apply(null, arguments)
      }
    }
  }) : (!_vm.focused) ? _c('span', {
    staticClass: "ms-kbd"
  }, [_vm._v(_vm._s(_vm.shortcutText))]) : _vm._e()], 1), _vm._v(" "), (_vm.focused) ? _c('div', {
    staticClass: "ms-panel",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [(!_vm.keyword.trim()) ? [(_vm.recentItems.length) ? [_c('div', {
    staticClass: "ms-section"
  }, [_c('span', [_vm._v("最近访问")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.clearRecent
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('ul', {
    ref: "list",
    staticClass: "ms-list"
  }, _vm._l((_vm.recentItems), function(item, index) {
    return _c('li', {
      key: item.url,
      staticClass: "ms-item",
      class: {
        'is-current': index === _vm.activeIndex
      },
      on: {
        "mouseenter": function($event) {
          _vm.activeIndex = index
        },
        "click": function($event) {
          return _vm.go(item)
        }
      }
    }, [_c('Icon', {
      staticClass: "ms-item-icon",
      attrs: {
        "type": "android-time"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ms-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "ms-path"
    }, [_vm._v(_vm._s(item.path))]), _vm._v(" "), _c('Icon', {
      staticClass: "ms-enter",
      attrs: {
        "type": "arrow-return-left"
      }
    })], 1)
  }), 0)] : _c('div', {
    staticClass: "ms-empty"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v("\n        " + _vm._s(_vm.items.length ? '输入菜单名称，快速跳转' : '菜单加载中…') + "\n      ")], 1)] : [(_vm.results.length) ? _c('ul', {
    ref: "list",
    staticClass: "ms-list"
  }, _vm._l((_vm.results), function(item, index) {
    return _c('li', {
      key: item.url,
      staticClass: "ms-item",
      class: {
        'is-current': index === _vm.activeIndex
      },
      on: {
        "mouseenter": function($event) {
          _vm.activeIndex = index
        },
        "click": function($event) {
          return _vm.go(item)
        }
      }
    }, [_c('Icon', {
      staticClass: "ms-item-icon",
      attrs: {
        "type": "ios-arrow-right"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ms-name"
    }, [_vm._l((item.segments), function(seg, i) {
      return [(seg.hit) ? _c('em', {
        key: i
      }, [_vm._v(_vm._s(seg.text))]) : [_vm._v(_vm._s(seg.text))]]
    })], 2), _vm._v(" "), _c('span', {
      staticClass: "ms-path"
    }, [_vm._v(_vm._s(item.path))]), _vm._v(" "), _c('Icon', {
      staticClass: "ms-enter",
      attrs: {
        "type": "arrow-return-left"
      }
    })], 1)
  }), 0) : _c('div', {
    staticClass: "ms-empty"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v("\n        没有找到「" + _vm._s(_vm.keyword.trim()) + "」相关的菜单\n      ")], 1)], _vm._v(" "), _vm._m(0)], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ms-footer"
  }, [_c('span', [_c('b', [_vm._v("↑")]), _c('b', [_vm._v("↓")]), _vm._v("选择")]), _vm._v(" "), _c('span', [_c('b', [_vm._v("Enter")]), _vm._v("打开")]), _vm._v(" "), _c('span', [_c('b', [_vm._v("Esc")]), _vm._v("关闭")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ae887b9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/MenuSearch.vue
// module id = 1633
// module chunks = 8